import { CartAddEvent, ThemeEvents } from '@theme/events';

class ProductWishlistButton extends HTMLElement {
  connectedCallback() {
    this.#button = this.querySelector('button');
    this.#message = this.querySelector('[data-message]');
    this.#sectionId = this.dataset.sectionId ?? '';

    this.#button?.addEventListener('click', this.#handleClick.bind(this));
    document.addEventListener(ThemeEvents.variantUpdate, this.#syncVariant.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.#syncVariant.bind(this));
  }

  /** @type {HTMLButtonElement | null} */
  #button = null;

  /** @type {HTMLElement | null} */
  #message = null;

  /** @type {string} */
  #sectionId = '';

  #syncVariant() {
    const variantInput = document.querySelector(
      `product-form-component[data-section-id="${this.#sectionId}"] input[name="id"]`
    );

    if (!(variantInput instanceof HTMLInputElement) || !this.#button) return;

    this.#button.dataset.variantId = variantInput.value;
  }

  async #handleClick() {
    if (!this.#button || this.#button.disabled) return;

    const variantId = this.#button.dataset.variantId;
    if (!variantId) return;

    this.#button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });

      if (!response.ok) throw new Error('Add to list failed');

      const data = await response.json();
      document.dispatchEvent(
        new CartAddEvent(data, this.#sectionId, {
          source: 'product-wishlist-button',
          itemCount: 1,
        })
      );

      if (this.#message) {
        this.#message.textContent = this.dataset.successMessage ?? 'Added to your list';
        this.#message.classList.remove('hidden');
      }
    } catch {
      if (this.#message) {
        this.#message.textContent = 'Unable to add to list. Please try again.';
        this.#message.classList.remove('hidden');
      }
    } finally {
      this.#button.disabled = false;
    }
  }
}

if (!customElements.get('product-wishlist-button')) {
  customElements.define('product-wishlist-button', ProductWishlistButton);
}
